// angular
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { SolutionsPeopleBrowseComponent } from '@app/+solutions/components/solutions-people-browse/solutions-people-browse.component';

@Component({
  selector: 'pwj-developers',
  standalone: true,
  imports: [TranslateModule, SolutionsPeopleBrowseComponent],
  templateUrl: './developers.component.html',
  styleUrl: './developers.component.scss',
})
export class DevelopersComponent {}
